import {
    Directive,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    inject
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BusyService } from "../../components/busy/busy.service";

@Directive({ selector: "[raskBusy]" })
export class BusyDirective implements OnInit, OnDestroy {
    @Input() raskBusy: string;

    private readonly busyService = inject(BusyService);
    private readonly destroy$ = new Subject<void>();
    private readonly elementRef = inject(ElementRef);
    private readonly renderer = inject(Renderer2);

    private spinnerElement: ElementRef;

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.injectSpinnerElement();
    }

    private createSpinnerElement() {
        const div = this.renderer.createElement("div");
        this.positionSpinner(div);
        this.spinnerElement = this.renderer.createElement("i");
        this.renderer.addClass(this.spinnerElement, "fas");
        this.renderer.addClass(this.spinnerElement, "fa-circle-notch");
        this.renderer.addClass(this.spinnerElement, "fa-spin");
        this.renderer.addClass(this.spinnerElement, "fa-1x");
        this.renderer.addClass(this.spinnerElement, "fa-fw");
        this.renderer.appendChild(div, this.spinnerElement);
        this.renderer.appendChild(this.elementRef.nativeElement.parentElement, div);
        this.setSpinnerVisibility(false);
    }

    private injectSpinnerElement() {
        this.createSpinnerElement();
        this.registerBusyWorkListener();
    }

    private positionSpinner(div: any) {
        this.renderer.setStyle(div, "width", "18px");
        this.renderer.setStyle(div, "position", "absolute");
        this.renderer.setStyle(div, "right", "-10px");
        this.renderer.setStyle(div, "top", "50%");
        this.renderer.setStyle(div, "margin-top", "5px");
    }

    private registerBusyWorkListener() {
        this.busyService.getChannel(this.raskBusy).isWorking.pipe(
            takeUntil(this.destroy$)
        ).subscribe(isWorking => {
            this.setSpinnerVisibility(isWorking);
        });
    }

    private setSpinnerVisibility(spinnerVisible: boolean) {
        // eslint-disable-next-line sonarjs/no-selector-parameter
        if (spinnerVisible) {
            this.renderer.removeAttribute(this.spinnerElement, "hidden");
            this.renderer.setAttribute(this.elementRef.nativeElement, "disabled", "true");
        } else {
            this.renderer.setAttribute(this.spinnerElement, "hidden", "true");
            this.renderer.removeAttribute(this.elementRef.nativeElement, "disabled");
        }
    }
}
